import React from 'react';
import { icons, LucideProps } from 'lucide-react';

// Lucide eksportuje ikony w PascalCase; design posluguje sie nazwami kebab-case.
// Aliasowanie nazw z prototypu na nowsze nazwy lucide (po rebrandzie ikon).
const ALIASES: Record<string, string> = {
  'bar-chart-3': 'ChartColumn',
  'file-bar-chart': 'FileChartColumn',
  'alert-circle': 'CircleAlert',
  'alert-triangle': 'TriangleAlert',
  'check-circle-2': 'CircleCheckBig',
  'x-circle': 'CircleX',
  'qr-code': 'QrCode',
};

function toPascal(name: string): string {
  if (ALIASES[name]) return ALIASES[name];
  return name
    .split('-')
    .map((p) => p.charAt(0).toUpperCase() + p.slice(1))
    .join('');
}

type IconProps = {
  name: string;
  size?: number;
  style?: React.CSSProperties;
  className?: string;
} & Omit<LucideProps, 'ref' | 'size'>;

export default function Icon({ name, size = 18, style, className, ...rest }: IconProps) {
  const Cmp = (icons as Record<string, React.ComponentType<LucideProps>>)[toPascal(name)];
  if (!Cmp) return null;
  return (
    <span className={className} style={{ display: 'inline-flex', lineHeight: 0, ...style }}>
      <Cmp size={size} {...rest} />
    </span>
  );
}
